import FundMappingsService from 'donor-elf-web/services/fund-mappings-service';
import {
  validatePresence,
  validateInclusion,
} from 'ember-changeset-validations/validators';
import { assignSingleProperty } from 'donor-elf-web/lib/object-utils';
import { isEmpty } from '@ember/utils';

export const EditFundMappingValidation = {
  fundName: validatePresence(true),
  fundActive: validateInclusion({ list: [true, false] }),
};

export const EditFundMappingHostIdentityValidation = {
  initialize(args: {
    editFundMappingChangeset: any;
    fundMappingsService: FundMappingsService;
  }) {
    return {
      database(
        _key: string,
        newValue: string /*, oldValue, changes, content*/,
      ) {
        if (isEmpty(newValue)) {
          if (
            args.fundMappingsService.availableDatabaseOptions.filter((x) =>
              isEmpty(x.val),
            ).length === 0
          ) {
            return "Can't be blank";
          }
        }
        return true;
      },
      hostId(
        _key: string,
        newValue: any,
        _oldValue: any,
        changes: any,
        content: any,
      ) {
        if ((newValue || '').length === 0) {
          return 'Mapping must be present';
        }
        if (newValue.startsWith(' ')) {
          return "Mapping can't start with spaces";
        }
        if (newValue.endsWith(' ')) {
          return "Mapping can't end with spaces";
        }

        let fundHostIdentities =
          args.editFundMappingChangeset.get('hostIdentities');
        if (fundHostIdentities) {
          let database = assignSingleProperty(content, changes, 'database');
          if (
            args.editFundMappingChangeset
              .get('hostIdentities')
              ?.filter(
                (x: any) => x.database === database && x.hostId === newValue,
              )?.length > 1
          ) {
            return 'Another row has the same mapping';
          }

          let thisFundId = args.editFundMappingChangeset.get('fundId');
          if (
            args.fundMappingsService.hostIdentities.filter(
              (x) =>
                x.database === database &&
                x.hostId === newValue &&
                x.identifiableId !== thisFundId,
            ).length > 0
          ) {
            return 'Another fund already has this mapping';
          }
        }
        return true;
      },
    };
  },
};
